import { useAppSelector } from "app/hooks"
import DailyProgressSkeleton from "./DailyProgressSkeleton"
import { IDailyCaloriesMode } from "features/profile/profileTypes"
import RemainingDailyProgress from "./RemainingDailyProgress"
import IntakeDailyProgress from "./IntakeDailyProgress"

const DailyProgress = () => {
  const isFirstLoadDiary = useAppSelector(
    (state) => state.home.isFirstLoadDiary,
  )

  const userPreferences = useAppSelector(
    (state) => state.profile.userPreferences,
  )

  const dailyCaloriesMode = userPreferences?.dailyCaloriesMode

  if (isFirstLoadDiary) {
    return <DailyProgressSkeleton />
  }

  return dailyCaloriesMode === IDailyCaloriesMode.INTAKE ? (
    <IntakeDailyProgress />
  ) : (
    <RemainingDailyProgress />
  )
}

export default DailyProgress
